import { Dropdown, Nav } from 'react-bootstrap';
import { CgProfile } from "react-icons/cg";
import { IoChatbubblesOutline, IoBookOutline, IoLogoGithub } from "react-icons/io5";
import { MdShowChart, MdWorkspacesFilled, MdDynamicFeed } from "react-icons/md";
import { VscDashboard, VscKey } from "react-icons/vsc";
import { LinkContainer } from 'react-router-bootstrap';
import pkg from '../../../package.json';
import { DisplayUser } from '../../features/auth/models/DisplayUser.interface';
import './Sidebar.scss';
import { useEffect, useState } from 'react';
import Logout from '../../features/auth/components/Logout';
import { getProtocolHostnameAndPort } from '../../shared/helpers/helpers';

interface SidebarProps {
    identity: DisplayUser | null | undefined
}

const Sidebar = ({ identity }: SidebarProps) => {
    const [childIdentity, setIdentity] = useState<DisplayUser | null | undefined>();
    useEffect(() => {
        if (identity) {
            setIdentity(identity);
        }

    }, [identity]);
    

    return (
        <div className="position-sticky sidebar-sticky d-flex flex-column">
            <a href="/" className="d-flex justify-content-start align-items-center mb-lg-5 mx-3">
                <img className="d-none d-lg-block" src="/Logo_Smash_API_Blanc.png" alt="" width={140}></img>
                <img className="d-block d-lg-none" src="/icono-chip-white.png" alt="" width={35}></img>
            </a>
            {/* <MenuItem /> */}
            <ul className="nav nav-pills flex-column mb-auto">
                <li className="nav-item">
                    <LinkContainer to="/" aria-current="page">
                        <Nav.Link>
                            <VscDashboard className="me-2" size="1.5em" />
                            <span className="d-none d-lg-inline">Overview</span>
                        </Nav.Link>
                    </LinkContainer >
                </li>
                <li>
                    <LinkContainer to="/reports">
                        <Nav.Link>
                            < MdShowChart className="me-2" size="1.5em" />
                            <span className="d-none d-lg-inline">Reports</span>
                        </Nav.Link>
                    </LinkContainer >
                </li>
                <li>
                    <LinkContainer to="/transfers">
                        <Nav.Link>
                            <MdDynamicFeed className="me-2" size="1.5em" />
                            <span className="d-none d-lg-inline">Transfers</span>
                        </Nav.Link>
                    </LinkContainer >
                </li>
                <li>
                    <LinkContainer to="/apikeys">
                        <Nav.Link>
                            < VscKey className="me-2" size="1.5em" />
                            <span className="d-none d-lg-inline">API Keys</span>
                        </Nav.Link>
                    </LinkContainer >
                </li>
                <li>
                    <LinkContainer to="/settings/domains">
                        <Nav.Link>
                            < MdWorkspacesFilled className="me-2" size="1.5em" />
                            <span className="d-none d-lg-inline">Settings</span>
                        </Nav.Link>
                    </LinkContainer >
                </li>
                {/* <li>
                    <LinkContainer to="/webhooks">
                        <Nav.Link>
                            < GiPulleyHook className="me-2" />
                            <span className="d-none d-lg-inline">Webhooks</span>
                        </Nav.Link>
                    </LinkContainer >
                </li>
                <li>
                    <LinkContainer to="/events">
                        <Nav.Link>
                            < MdEventNote className="me-2" />
                            <span className="d-none d-lg-inline">Events</span>
                        </Nav.Link>
                    </LinkContainer >
                </li> */}
                {/* <li>
                    <Nav.Link onClick={logoutHandler}>
                        <FaSignOutAlt className="me-2" />
                        <span className="d-none d-lg-inline">Sign out</span>
                    </Nav.Link>
                </li> */}
            </ul>            

            <div className="sticky-bottom d-none d-lg-block">
                <a target="_blank" rel="noreferrer" href="https://github.com/fromsmash" className="text-light d-none d-lg-block ms-3 text-decoration-none pb-2" style={{fontSize: "14px"}} >
                    <IoLogoGithub className="me-2" size="1.3em" />Github
                </a>
                <a target="_blank" rel="noreferrer" href={`${getProtocolHostnameAndPort()}/docs`} className="text-light d-none d-lg-block ms-3 text-decoration-none pb-2" style={{fontSize: "14px"}} >
                    <IoBookOutline className="me-2" size="1.3em" />Documentation
                </a>
                <a target="_blank" rel="noreferrer" href="https://discord.com/invite/ajHD7AKY8R" className="text-light d-none d-lg-block ms-3 text-decoration-none" style={{fontSize: "14px"}} >
                    <IoChatbubblesOutline className="me-2" size="1.3em" />Developer chat on Discord
                </a>
                <hr />
                {/* <SubMenuItem /> */}
                <Dropdown className="d-grid">
                    <Dropdown.Toggle variant="primary" className="d-flex align-items-center">
                        <CgProfile size="2em" />
                        <div className="d-flex flex-column d-none d-lg-block text-start fs-7 px-1 ">
                            <div><strong>{childIdentity?.firstName}</strong></div>
                            <div className="text-truncate col-10"><small>{childIdentity?.username}</small></div>
                        </div>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="dropdown-menu text-small shadow">

                        <LinkContainer to="/profile">
                            <Dropdown.Item className="dropdown-item">Profile</Dropdown.Item>
                        </LinkContainer>
                        <LinkContainer to="/billing">
                            <Dropdown.Item className="dropdown-item">Billing</Dropdown.Item>
                        </LinkContainer>

                        <Dropdown.Divider />
                        <Dropdown.Item className="dropdown-item" ><Logout/></Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
                <p className="text-light d-none d-lg-block mt-3 mb-0 text-end" style={{fontSize: "11px"}}>v{pkg.version}</p>

            </div>
        </div>
    )
}

export default Sidebar
